import React, {useEffect, useState} from 'react';
import {View} from 'react-native';
// optimization for
const DelayedLoad = ({
  children,
  delay = 1000,
  loadingStyle = {},
  skipDelay = 0,
}) => {
  const [hasLoaded, setHasLoaded] = useState(skipDelay);
  useEffect(() => {
    if (!skipDelay) {
      setTimeout(() => {
        setHasLoaded(1);
      }, delay);
    }
  }, []);
  if (!hasLoaded) {
    return <View style={{flex: 1, ...loadingStyle}}></View>;
  }

  return <>{children}</>;
};

export default DelayedLoad;
